import axios from "axios";

/**
 * Fetch the table list data.
 * @param {Object} params - Parameters for the API call.
 * @param {string} params.access_token - Access token for authentication.
 * @param {number} params.id - ID to filter data.
 * @param {number} params.page - Current page number.
 * @param {number} params.limit - Number of items per page.
 * @returns {Promise<Object>} - API response data.
 */
export const fetchTableList = async ({ id, page = 1 }) => {
  if (!id) {
    throw new Error("ID is required to fetch data.");
  }

  const access_token = localStorage.getItem("@user");

  try {
    const response = await axios.get(
      "https://htprdapi.hightable.ai/tables/my-list",
      {
        params: {
          access_token,
          id,
          page,
          limit: 30,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching table list:", error);
    throw error;
  }
};
